<template>
  <div class="view-buttons">
    <div class="buttons-on-indoorview">
      <MapViewButton @mapviewButtonClick="handleMapviewButtonClick" />
      <PlanViewButton v-if="isBuildingSelected" />
      <SelectBuildingIvionButton
        v-if="isBuildingSelected"
        :disabled="disabledViewButton1"
        :viewerNumber="1"
      />
      <SelectRealEstateIvionButton
        v-if="!isBuildingSelected"
        :disabled="disabledViewButton1"
        :viewerNumber="1"
      />
    </div>
  </div>
  <div class="view-buttons-split-indoorviewer">
    <SelectBuildingIvionButton
      v-if="splitIndoorViewer && isBuildingSelected"
      :disabled="disabledViewButton2"
      :viewerNumber="2"
    />
    <SelectRealEstateIvionButton
      v-if="splitIndoorViewer && !isBuildingSelected"
      :disabled="disabledViewButton2"
      :viewerNumber="2"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_CLICKED_ITEM_TYPE } from '@/store/mutation-types'
import SelectBuildingIvionButton from '@/components/general/ViewButtons/indoorview-buttons/SelectBuildingIvionButton.vue'
import SelectRealEstateIvionButton from '@/components/general/ViewButtons/indoorview-buttons/SelectRealEstateIvionButton.vue'
import { PlanViewButton } from '@/components/general/ViewButtons/mapview-buttons'
import { MapViewButton } from '@/components/general/ViewButtons/planview-buttons'
import { setViewToMapview } from '@/utils/views'
import { zoomToEntities } from '@/composables/useMapbox'
export default {
  name: 'ViewButtonsIndoor',
  components: {
    PlanViewButton,
    MapViewButton,
    SelectBuildingIvionButton,
    SelectRealEstateIvionButton
  },
  props: {
    disabledViewButton1: {
      type: Boolean,
      default: false
    },
    disabledViewButton2: {
      type: Boolean,
      default: false
    },
    splitIndoorViewer: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changeInstance1', 'changeInstance2'],
  computed: {
    ...mapGetters({
      allRealEstates: 'allRealEstates',
      allBuildings: 'allBuildings'
    }),
    ...mapState({
      previousView: (state) => state.previousView
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedBuilding: (state) => state.selectedBuilding,
      selectedRealEstate: (state) => state.selectedRealEstate
    }),
    isBuildingSelected() {
      return Object.keys(this.selectedBuilding).length > 0
    }
  },
  methods: {
    async handleMapviewButtonClick() {
      await setViewToMapview()
      setTimeout(() => {
        if (this.isBuildingSelected) {
          this.setClickedItemType({ type: 'level' })
          zoomToEntities([this.selectedBuilding.id])
          return
        }

        if (this.selectedRealEstate) {
          zoomToEntities([this.selectedRealEstate.id])
        }
      }, 10)
    },
    ...mapMutations({
      setClickedItemType: SET_CLICKED_ITEM_TYPE
    })
  }
}
</script>

<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/styles/variables' as old-variables;
.buttons-on-indoorview {
  display: flex;
  align-items: flex-end;
}
.view-buttons {
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: absolute;
  left: calc(#{old-variables.$margin-small + old-variables.$margin-small});
  bottom: calc(#{old-variables.$margin-small + old-variables.$margin-small});
  z-index: variables.$z-index-map-buttons;
}
.view-buttons-split-indoorviewer {
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: absolute;
  right: calc(#{old-variables.$margin-small + old-variables.$margin-small} + 40px);
  bottom: calc(#{old-variables.$margin-small + old-variables.$margin-small});
  z-index: variables.$z-index-map-toolbox;
}
@media screen and (max-width: 1024px) {
  .view-buttons-split-indoorviewer {
    display: none;
  }
  .view-buttons {
    bottom: 0;
    height: variables.$view-buttons-height;
    justify-content: center;
    left: 0;
    overflow-y: visible;
    width: 100vw;
    z-index: variables.$z-index-view-buttons-mobile;

    .buttons-on-indoorview {
      column-gap: variables.$gap-medium;
      height: fit-content;
      padding-bottom: variables.$padding-large;
    }
  }
}
</style>
